import React from 'react';
import { useHistory } from 'react-router-dom';
import { matchPath } from 'react-router';
import Button from 'root/components/Button';
import { getInternalPath } from '../../utils';
import SVGs from '~/assets/icons/icons';

const isMatchLocationPath = (id, history, path = '') => {
  return matchPath(history.location.pathname, {
    path: getInternalPath(id, path),
    exact: true,
  });
};

export const TabHeaderButtons = ({ id, routes, searchTerm, isFiltersPanelOpen, clearSearchTerm, showIndicator, toggleFilterPanel, filterBtnDataTest }) => {
  // TODO: RETURN HOME BUTTON AFTER UX ISSUES RESOLVED
  // const history = useHistory();
  // const isHomePage = isMatchLocationPath(id, history, routes.HOME);
  // const isSearchPage = isMatchLocationPath(id, history,routes.SEARCH);

  return (
    <>
      <Button
        dataTest={filterBtnDataTest ? filterBtnDataTest : `${id}-filter-panel-toggle-${isFiltersPanelOpen ? 'open' : 'closed'}`}
        textColorName="menu-icons"
        icon={isFiltersPanelOpen ? SVGs.LT_ARROW : SVGs.SLIDERS}
        iconSize="sm"
        fontSize={12}
        onClick={toggleFilterPanel}
        showIndicator={showIndicator}
      />
      {/*TODO: RETURN HOME BUTTON AFTER UX ISSUES RESOLVED*/}
      {/*<Button*/}
      {/*	dataTest={`${id}-home`}*/}
      {/*	textColorName="menu-icons"*/}
      {/*	icon={SVGs.HOME}*/}
      {/*	iconSize="lg"*/}
      {/*	onClick={clearSearchTerm}*/}
      {/*	disabled={isHomePage || (isSearchPage && !searchTerm) }*/}
      {/*/>*/}
    </>
  );
};

export default TabHeaderButtons;
